import { createTheme as createMuiTheme } from "@mui/material/styles";
import { components } from "./components/components";
import { shadows } from "./shadows";
import type { Theme as MuiTheme } from "@mui/material/styles";
import { typography } from "./typography";

declare module "@mui/material/styles/createPalette" {
  interface PaletteRange {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    950: string;
  }

  interface Palette {
    neutral: PaletteRange;
  }

  interface PaletteOptions {
    neutral?: PaletteRange;
  }

  interface TypeBackground {
    level1: string;
    level2: string;
    level3: string;
  }

  interface PaletteColor {
    lighter?: string;
  }

  interface SimplePaletteColorOptions {
    lighter?: string;
  }
}

export function createTheme(): MuiTheme {
  return createMuiTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#E9672D",
        light: "#F0915F",
        dark: "#C24E1C",
        lighter: "#FDEEE6",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#2F3A45",
        light: "#55636F",
        dark: "#1F2730",
        lighter: "#EAEDF0",
        contrastText: "#FFFFFF",
      },
      background: {
        default: "#F6F7F9",
        paper: "#FFFFFF",
        level1: "#F8FAFC",
        level2: "#EEF2F6",
        level3: "#E4E7EC",
      },
      neutral: {
        50: "#FAFAFA",
        100: "#F5F5F5",
        200: "#EEEEEE",
        300: "#E0E0E0",
        400: "#BDBDBD",
        500: "#9E9E9E",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        950: "#1A1A1A",
      },
    },
    breakpoints: {
      values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1440 },
    },
    components,
    shadows,
    shape: { borderRadius: 8 },
    typography: {
      ...typography,
    },
  });
}
